export default __webpack_public_path__ + "src/assets/unisethBreakdown.bd622ffe53ed6fb9c9c88d26eff5a2c9.svg";